import React from "react"
import {Link} from "gatsby"
import Style from "../styles/address.module.css"

export default (props) => (
    <div className={Style.box}>
        <p>当前位置：<Link to="/">主&nbsp;页</Link> > {props.classUrl ? <Link to={props.classUrl}>{props.className}</Link> : props.className} > 
        </p>
    </div>
)